const Data = [
  {
    id: 1,
    title: "On route vehicles",
    number: "42",
    percentage: +18.2,
    text: "than last week",
    icon: "fa fa-truck",
    color: "blue",
  },
  {
    id: 2,
    title: "Vehicles with errors",
    number: "8",
    percentage: -8.7,
    text: "than last week",
    icon: "fa-solid fa-triangle-exclamation",
    color: "red",
  },
  {
    id: 3,
    title: "Deviated from route",
    number: "27",
    percentage: +4.3,
    text: "than last week",
    icon: "fa-solid fa-route",
    color: "amber",
  },
  {
    id: 4,
    title: "Late vehicles",
    number: "13",
    percentage: -2.5,
    text: "than last week",
    icon: "fa-solid fa-clock",
    color: "sky",
  },
];

interface props {
  list: any;
}
const CountCards = ({ list }: props) => {
  const sortlist = list.sort((a: any, b: any) => b.id - a.id);

  const uniqueByTrailer = sortlist.filter(
    (item: any, index: number, self: any) =>
      index === self.findIndex((t: any) => t.vehicle_id === item.vehicle_id),
  );
  return (
    <>
      {Data?.map(
        ({ title, number, percentage, text, icon, color }, index: number) => (
          <div className="col-span-12 md:col-span-3" key={index}>
            <div
              className={`bg-white  border border-b-[2px] border-${color}-500 border-t-gray-200 border-x-gray-200 h-full rounded-md p-4`}
            >
              <div className="flex items-center mb-2">
                <div className="me-4">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded bg-${color}-100 text-${color}-600`}
                  >
                    <i className={`${icon} text-xl`}></i>
                  </div>
                </div>
                <h4 className="text-lg font-semibold mb-0">{number}</h4>
              </div>
              <p className={`mb-2 text-md text-gray-500`}>{title}</p>
              <p className="text-sm text-gray-700 mb-0">
                <span
                  className={`font-medium mr-2 ${percentage >= 0 ? "text-green-600" : "text-red-600"}`}
                >
                  {percentage > 0 ? `+${percentage}%` : `${percentage}%`}
                </span>
                <span className="text-gray-500">{text}</span>
              </p>
            </div>
          </div>
        ),
      )}
    </>
  );
};

export default CountCards;
